import { calculateOfferDuration } from '@/constants/hooks';
import { faCalendarDays, FontAwesomeIcon } from '@/constants/icons';
import React from 'react'

interface Props {
    endDate: string | null;
    className?: string;
}

const OfferDuration = ({ endDate, className }: Props) => {
    const durationText = calculateOfferDuration(endDate);
    const isExpiring = endDate !== null && endDate !== undefined;

    return (
        <div className={`flex items-center gap-1.5 ${className ?? ''}`}>
            {isExpiring ? (
                /* ── Expiring / Limited Time ── */
                <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-50 border border-amber-100">
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="w-3 h-3 text-amber-500"
                    />
                    <span className="text-[10px] font-semibold text-amber-600">
                        {durationText}
                    </span>
                </div>
            ) : (
                /* ── Always Active / Verified ── */
                <div
                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-md"
                    style={{
                        background: 'rgba(74,154,110,0.08)',
                        border: '1px solid rgba(74,154,110,0.15)',
                    }}
                >
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="w-3 h-3"
                        style={{ color: '#5D27A1' }}
                    />
                    <span
                        className="text-[10px] font-semibold"
                        style={{ color: '#5D27A1' }}
                    >
                        {durationText}
                    </span>
                </div>
            )}
        </div>
    );
}

export default OfferDuration
